/* Лабораторії: відправлення в зовнішні лабораторії (/lab/shipments, /lab/labs). Kept apart from uk.ts/en.ts to keep merges small. */
export const labshipUk = {
  'nav.labShipments': 'Лабораторії',
  'nav.labSettings': 'Лабораторії й правила',
  'perm.lab_shipments.work': 'Відправлення в зовнішні лабораторії',
  'perm.lab_shipments.manage': 'Довідник лабораторій і типів зразків',
  'process.area.lab': 'Лабораторія',
  'lab.title': 'Лабораторії',
  'lab.subtitle': 'Відправлення біоматеріалу в зовнішні лабораторії: прострочені — першими. Результат з Enote закриває відправлення автоматично.',
  'lab.new': 'Нове відправлення',
  'lab.settings': 'Лабораторії й правила',
  'lab.tab.open': 'Очікують результат',
  'lab.tab.overdue': 'Прострочені',
  'lab.tab.unreviewed': 'Не переглянуті',
  'lab.tab.results': 'Результати',
  'lab.tab.all': 'Усі',
  'lab.allLabs': 'Усі лабораторії',
  'lab.allBranches': 'Усі філії',
  'lab.search': 'Тварина, власник, дослідження, ТТН або номер',
  'lab.empty': 'Відправлень немає',
  'lab.emptyHint': 'Натисніть «Нове відправлення» і оберіть дослідження з Enote — Bridge порахує дату результату й нагадає, якщо він запізнюється.',
  'lab.emptyOverdue': 'Прострочених результатів немає',
  'lab.emptyUnreviewed': 'Усі результати переглянуто',
  'lab.col.number': '№',
  'lab.col.patient': 'Пацієнт',
  'lab.col.study': 'Дослідження',
  'lab.col.lab': 'Лабораторія',
  'lab.col.status': 'Статус',
  'lab.col.expected': 'Очікуємо',
  'lab.col.waybill': 'ТТН',
  'lab.status.prepared': 'Готується',
  'lab.status.sent': 'Відправлено',
  'lab.status.received': 'У лабораторії',
  'lab.status.result': 'Результат отримано',
  'lab.status.failed': 'Невдача',
  'lab.status.do_not_send': 'Не відправляти власнику',
  'lab.status.cancelled': 'Скасовано',
  'lab.overdue': 'Прострочено',
  'lab.overdueBy': 'прострочено на {n} дн.',
  'lab.expectedToday': 'сьогодні',
  'lab.expectedTomorrow': 'завтра',
  'lab.expectedIn': 'через {n} дн.',
  'lab.expectedManual': 'дату змінено вручну',
  'lab.sampleOverdue': 'Зразок чекає задовго',
  'lab.sampleOverdueHint': 'Минув допустимий час від забору до обробки чи відправки',
  'lab.notReviewed': 'Не переглянуто',
  'lab.reviewed': 'Переглянуто',
  'lab.reviewedBy': 'Переглянуто: {who}, {when}',
  'lab.autoClosed': 'Результат надійшов з Enote',
  'lab.cash': 'Готівка в посилці',
  'lab.cashAmount': 'Сума готівки, грн',
  'lab.delivery.post': 'Нова пошта',
  'lab.delivery.courier': 'Кур’єр лабораторії',
  'lab.delivery.owner': 'Везе власник',
  'lab.delivery.staff': 'Везе співробітник',
  'lab.requisition.paper': 'Паперовий бланк',
  'lab.requisition.portal': 'Е-направлення на порталі',
  'lab.requisition.pc_form': 'Файл на лабораторному ПК (друк)',
  'lab.requisition.owner_eform': 'Е-направлення заповнює власник',
  'lab.requisition.doctor_eform': 'Е-направлення заповнює лікар',
  'lab.courier.nova_poshta': 'Нова пошта',
  'lab.courier.lab_courier': 'Кур’єр лабораторії',
  'lab.courier.owner': 'Власник',
  'lab.courier.staff': 'Співробітник',
  'lab.drawerTitle': 'Відправлення №{n}',
  'lab.section.rules': 'Правила лабораторії',
  'lab.section.checklist': 'Чекліст перед відправкою',
  'lab.section.sample': 'Зразок',
  'lab.section.shipment': 'Відправка',
  'lab.section.history': 'Історія',
  'lab.section.edit': 'Змінити',
  'lab.field.lab': 'Лабораторія',
  'lab.field.study': 'Дослідження',
  'lab.field.sampleType': 'Тип зразка',
  'lab.field.noSampleType': 'Не вказано',
  'lab.field.takenAt': 'Забір',
  'lab.field.deadline': 'Обробити / відправити до',
  'lab.field.branch': 'Філія',
  'lab.field.anyBranch': 'Не вказано',
  'lab.field.courier': 'Як відправлено',
  'lab.field.waybill': 'ТТН / номер відправлення',
  'lab.field.sentAt': 'Відправлено',
  'lab.field.expected': 'Очікуємо результат',
  'lab.field.expectedHint': 'Залиште порожнім, щоб дату рахував Bridge за правилами лабораторії',
  'lab.field.notes': 'Нотатки',
  'lab.field.doctor': 'Лікар',
  'lab.field.enote': 'Дослідження Enote',
  'lab.field.delivery': 'Доставка',
  'lab.field.requisition': 'Направлення',
  'lab.field.portal': 'Портал',
  'lab.field.contact': 'Куди звертатися',
  'lab.field.payment': 'Оплата',
  'lab.field.packaging': 'Пакування',
  'lab.field.noSend': 'Не відправляти',
  'lab.field.cutoff': 'Відправлене після',
  'lab.field.rule': 'Строк для цього дослідження',
  'lab.ruleDays': '{study}: {n} дн.',
  'lab.defaultDays': 'Звичайний строк: {n} дн.',
  'lab.cutoffHint': 'Відправлене після {time} рахується з наступного дня',
  'lab.sendBlockedToday': 'Сьогодні ця лабораторія відправлень не приймає',
  'lab.checklistOpen': 'Заповніть чекліст — без нього відправку не позначити',
  'lab.checklistDone': 'Чекліст виконано',
  'lab.openChecklist': 'Відкрити чекліст',
  'lab.markSent': 'Відправлено',
  'lab.markSentTitle': 'Позначити відправку',
  'lab.force': 'Відправити попри день без відправок',
  'lab.toStatus.received': 'Отримано лабораторією',
  'lab.toStatus.result': 'Результат отримано',
  'lab.toStatus.failed': 'Невдача',
  'lab.toStatus.do_not_send': 'Не відправляти власнику',
  'lab.toStatus.cancelled': 'Скасувати відправлення',
  'lab.reasonTitle': 'Причина',
  'lab.reasonHint': 'Збережеться в історії відправлення',
  'lab.markReviewed': 'Переглянуто',
  'lab.markReviewedHint': 'Результат з Enote стане доступним власнику (крім «Не відправляти власнику»).',
  'lab.event.created': 'Створено',
  'lab.event.updated': 'Змінено',
  'lab.event.sent': 'Відправлено',
  'lab.event.status': 'Статус',
  'lab.event.result': 'Результат',
  'lab.event.reviewed': 'Переглянуто лікарем',
  'lab.event.overdue': 'Нагадування: результат прострочено',
  'lab.system': 'Bridge',
  'lab.newTitle': 'Нове відправлення',
  'lab.newHint': 'Оберіть дослідження з Enote без результату. Bridge підставить пацієнта, лікаря й лабораторію за назвою шаблону.',
  'lab.candidatesSearch': 'Пошук: тварина, власник, дослідження',
  'lab.noCandidates': 'Немає досліджень без результату за 14 днів',
  'lab.noCandidatesHint': 'Спочатку створіть дослідження в Enote (шаблон «Дослідження у зовнішній лабораторії») і дочекайтеся синхронізації.',
  'lab.suggested': 'лабораторія за назвою: {lab}',
  'lab.pickLab': 'Оберіть лабораторію',
  'lab.expectedPreview': 'Якщо відправити сьогодні, результат очікуємо {date}',
  'lab.create': 'Створити й відкрити чекліст',
  'lab.created': 'Відправлення створено. Заповніть чекліст перед відправкою.',
  'lab.saved': 'Збережено',
  'lab.labsTitle': 'Лабораторії й правила',
  'lab.labsSubtitle': 'Зовнішні лабораторії, строки результатів за типами досліджень і типи зразків. Значення «Уточнити» чекають підтвердження власника.',
  'lab.tabLabs': 'Лабораторії',
  'lab.tabSamples': 'Типи зразків',
  'lab.addLab': 'Додати лабораторію',
  'lab.addSample': 'Додати тип зразка',
  'lab.seed': 'Додати стандартні',
  'lab.seeded': 'Стандартні лабораторії, типи зразків і чекліст додано',
  'lab.noLabs': 'Лабораторій ще немає',
  'lab.noLabsHint': 'Додайте стандартні лабораторії з регламенту клініки або створіть власну.',
  'lab.noSamples': 'Типів зразків ще немає',
  'lab.toConfirm': 'Уточнити',
  'lab.confirmed': 'Підтверджено',
  'lab.archived': 'В архіві',
  'lab.showArchived': 'Показати архівні',
  'lab.col.name': 'Назва',
  'lab.col.city': 'Місто',
  'lab.col.days': 'Строк',
  'lab.col.rules': 'Правила',
  'lab.col.maxTime': 'Допустимий час',
  'lab.col.storage': 'Зберігання',
  'lab.col.state': 'Стан',
  'lab.daysN': '{n} дн.',
  'lab.rulesN': 'правил: {n}',
  'lab.noLimit': 'без обмеження',
  'lab.editLab': 'Лабораторія',
  'lab.editSample': 'Тип зразка',
  'lab.field.key': 'Ключ',
  'lab.field.keyHint': 'Латиниця, цифри й «_»; після створення не змінюється',
  'lab.field.name': 'Назва',
  'lab.field.city': 'Місто',
  'lab.field.aliases': 'Слова в назві шаблону Enote',
  'lab.field.aliasesHint': 'Через кому, наприклад: Лімарія, Limaria',
  'lab.field.rulesText': 'Що робити при відправці',
  'lab.field.defaultDays': 'Звичайний строк, днів',
  'lab.field.cutoffTime': 'Час відсічення (ГГ:ХХ)',
  'lab.field.cutoffTimeHint': 'Порожньо — норматив клініки (18:00)',
  'lab.field.markup': 'Коефіцієнт ціни',
  'lab.field.status': 'Стан правил',
  'lab.field.active': 'Активна',
  'lab.field.sort': 'Порядок',
  'lab.field.turnaround': 'Строки за типами досліджень',
  'lab.field.turnStudy': 'Тип дослідження',
  'lab.field.turnMatch': 'Слова (через кому)',
  'lab.field.turnDays': 'Днів',
  'lab.field.turnCutoff': 'Відсічення',
  'lab.field.title': 'Назва',
  'lab.field.maxMinutes': 'Допустимий час до обробки, хв',
  'lab.field.maxMinutesHint': 'Порожньо — без обмеження',
  'lab.field.storage': 'Зберігання',
  'lab.addRule': 'Додати строк',
  'lab.removeRule': 'Видалити строк',
  'today.overdueShipments': 'Прострочені результати лабораторій',
  'today.noOverdueShipments': 'Усі результати лабораторій вчасно',
}

export const labshipEn: { [K in keyof typeof labshipUk]?: string } = {
  'nav.labShipments': 'Labs',
  'nav.labSettings': 'Labs and rules',
  'perm.lab_shipments.work': 'Shipments to external labs',
  'perm.lab_shipments.manage': 'External labs and sample types',
  'process.area.lab': 'Laboratory',
  'lab.title': 'Labs',
  'lab.subtitle': 'Samples sent to external labs, overdue first. A result synced from Enote closes the shipment automatically.',
  'lab.new': 'New shipment',
  'lab.settings': 'Labs and rules',
  'lab.tab.open': 'Waiting for result',
  'lab.tab.overdue': 'Overdue',
  'lab.tab.unreviewed': 'Not reviewed',
  'lab.tab.results': 'Results',
  'lab.tab.all': 'All',
  'lab.allLabs': 'All labs',
  'lab.allBranches': 'All branches',
  'lab.search': 'Pet, owner, study, waybill or number',
  'lab.empty': 'No shipments',
  'lab.emptyHint': 'Click «New shipment» and pick a study from Enote — Bridge computes the result date and reminds you when it is late.',
  'lab.emptyOverdue': 'No overdue results',
  'lab.emptyUnreviewed': 'All results reviewed',
  'lab.col.number': 'No.',
  'lab.col.patient': 'Patient',
  'lab.col.study': 'Study',
  'lab.col.lab': 'Lab',
  'lab.col.status': 'Status',
  'lab.col.expected': 'Expected',
  'lab.col.waybill': 'Waybill',
  'lab.status.prepared': 'Preparing',
  'lab.status.sent': 'Sent',
  'lab.status.received': 'At the lab',
  'lab.status.result': 'Result received',
  'lab.status.failed': 'Failed',
  'lab.status.do_not_send': 'Do not send to owner',
  'lab.status.cancelled': 'Cancelled',
  'lab.overdue': 'Overdue',
  'lab.overdueBy': 'overdue by {n} d',
  'lab.expectedToday': 'today',
  'lab.expectedTomorrow': 'tomorrow',
  'lab.expectedIn': 'in {n} d',
  'lab.expectedManual': 'date set by hand',
  'lab.sampleOverdue': 'Sample waiting too long',
  'lab.sampleOverdueHint': 'The time allowed from sampling to processing or sending has passed',
  'lab.notReviewed': 'Not reviewed',
  'lab.reviewed': 'Reviewed',
  'lab.reviewedBy': 'Reviewed: {who}, {when}',
  'lab.autoClosed': 'Result arrived from Enote',
  'lab.cash': 'Cash in parcel',
  'lab.cashAmount': 'Cash amount, UAH',
  'lab.delivery.post': 'Nova Poshta',
  'lab.delivery.courier': 'Lab courier',
  'lab.delivery.owner': 'Owner takes it',
  'lab.delivery.staff': 'Staff takes it',
  'lab.requisition.paper': 'Paper form',
  'lab.requisition.portal': 'Portal e-requisition',
  'lab.requisition.pc_form': 'File on the lab PC (print)',
  'lab.requisition.owner_eform': 'Owner fills the e-form',
  'lab.requisition.doctor_eform': 'Doctor fills the e-form',
  'lab.courier.nova_poshta': 'Nova Poshta',
  'lab.courier.lab_courier': 'Lab courier',
  'lab.courier.owner': 'Owner',
  'lab.courier.staff': 'Staff',
  'lab.drawerTitle': 'Shipment #{n}',
  'lab.section.rules': 'Lab rules',
  'lab.section.checklist': 'Pre-send checklist',
  'lab.section.sample': 'Sample',
  'lab.section.shipment': 'Shipment',
  'lab.section.history': 'History',
  'lab.section.edit': 'Edit',
  'lab.field.lab': 'Lab',
  'lab.field.study': 'Study',
  'lab.field.sampleType': 'Sample type',
  'lab.field.noSampleType': 'Not set',
  'lab.field.takenAt': 'Taken',
  'lab.field.deadline': 'Process / send by',
  'lab.field.branch': 'Branch',
  'lab.field.anyBranch': 'Not set',
  'lab.field.courier': 'Sent via',
  'lab.field.waybill': 'Waybill / reference',
  'lab.field.sentAt': 'Sent',
  'lab.field.expected': 'Result expected',
  'lab.field.expectedHint': 'Leave empty to let Bridge compute it from the lab rules',
  'lab.field.notes': 'Notes',
  'lab.field.doctor': 'Doctor',
  'lab.field.enote': 'Enote study',
  'lab.field.delivery': 'Delivery',
  'lab.field.requisition': 'Requisition',
  'lab.field.portal': 'Portal',
  'lab.field.contact': 'Who to contact',
  'lab.field.payment': 'Payment',
  'lab.field.packaging': 'Packaging',
  'lab.field.noSend': 'Do not send on',
  'lab.field.cutoff': 'Sent after',
  'lab.field.rule': 'Result time for this study',
  'lab.ruleDays': '{study}: {n} d',
  'lab.defaultDays': 'Usual time: {n} d',
  'lab.cutoffHint': 'Sent after {time} counts from the next day',
  'lab.sendBlockedToday': 'This lab does not accept shipments sent today',
  'lab.checklistOpen': 'Complete the checklist — sending needs it',
  'lab.checklistDone': 'Checklist completed',
  'lab.openChecklist': 'Open checklist',
  'lab.markSent': 'Sent',
  'lab.markSentTitle': 'Mark as sent',
  'lab.force': 'Send despite the no-send day',
  'lab.toStatus.received': 'Received by the lab',
  'lab.toStatus.result': 'Result received',
  'lab.toStatus.failed': 'Failed',
  'lab.toStatus.do_not_send': 'Do not send to owner',
  'lab.toStatus.cancelled': 'Cancel shipment',
  'lab.reasonTitle': 'Reason',
  'lab.reasonHint': 'Kept in the shipment history',
  'lab.markReviewed': 'Reviewed',
  'lab.markReviewedHint': 'The Enote result becomes available to the owner (except «Do not send to owner»).',
  'lab.event.created': 'Created',
  'lab.event.updated': 'Changed',
  'lab.event.sent': 'Sent',
  'lab.event.status': 'Status',
  'lab.event.result': 'Result',
  'lab.event.reviewed': 'Reviewed by the doctor',
  'lab.event.overdue': 'Reminder: result overdue',
  'lab.system': 'Bridge',
  'lab.newTitle': 'New shipment',
  'lab.newHint': 'Pick an Enote study without a result. Bridge fills in the patient, the doctor and the lab from the template name.',
  'lab.candidatesSearch': 'Search: pet, owner, study',
  'lab.noCandidates': 'No studies without a result in the last 14 days',
  'lab.noCandidatesHint': 'Create the study in Enote first (template «Study in an external lab») and wait for the sync.',
  'lab.suggested': 'lab from the name: {lab}',
  'lab.pickLab': 'Choose a lab',
  'lab.expectedPreview': 'Sent today, the result is expected {date}',
  'lab.create': 'Create and open checklist',
  'lab.created': 'Shipment created. Complete the pre-send checklist.',
  'lab.saved': 'Saved',
  'lab.labsTitle': 'Labs and rules',
  'lab.labsSubtitle': 'External labs, result times per study type and sample types. «To confirm» values wait for the owner.',
  'lab.tabLabs': 'Labs',
  'lab.tabSamples': 'Sample types',
  'lab.addLab': 'Add lab',
  'lab.addSample': 'Add sample type',
  'lab.seed': 'Add defaults',
  'lab.seeded': 'Default labs, sample types and checklist added',
  'lab.noLabs': 'No labs yet',
  'lab.noLabsHint': 'Add the default labs from the clinic regulations or create your own.',
  'lab.noSamples': 'No sample types yet',
  'lab.toConfirm': 'To confirm',
  'lab.confirmed': 'Confirmed',
  'lab.archived': 'Archived',
  'lab.showArchived': 'Show archived',
  'lab.col.name': 'Name',
  'lab.col.city': 'City',
  'lab.col.days': 'Time',
  'lab.col.rules': 'Rules',
  'lab.col.maxTime': 'Allowed time',
  'lab.col.storage': 'Storage',
  'lab.col.state': 'State',
  'lab.daysN': '{n} d',
  'lab.rulesN': 'rules: {n}',
  'lab.noLimit': 'no limit',
  'lab.editLab': 'Lab',
  'lab.editSample': 'Sample type',
  'lab.field.key': 'Key',
  'lab.field.keyHint': 'Latin letters, digits and «_»; fixed after creation',
  'lab.field.name': 'Name',
  'lab.field.city': 'City',
  'lab.field.aliases': 'Words in the Enote template name',
  'lab.field.aliasesHint': 'Comma-separated, e.g. Limaria, Лімарія',
  'lab.field.rulesText': 'What to do when sending',
  'lab.field.defaultDays': 'Usual time, days',
  'lab.field.cutoffTime': 'Cut-off (HH:MM)',
  'lab.field.cutoffTimeHint': 'Empty — the clinic norm (18:00)',
  'lab.field.markup': 'Price coefficient',
  'lab.field.status': 'Rules state',
  'lab.field.active': 'Active',
  'lab.field.sort': 'Order',
  'lab.field.turnaround': 'Result time per study type',
  'lab.field.turnStudy': 'Study type',
  'lab.field.turnMatch': 'Words (comma-separated)',
  'lab.field.turnDays': 'Days',
  'lab.field.turnCutoff': 'Cut-off',
  'lab.field.title': 'Title',
  'lab.field.maxMinutes': 'Allowed time before processing, min',
  'lab.field.maxMinutesHint': 'Empty — no limit',
  'lab.field.storage': 'Storage',
  'lab.addRule': 'Add result time',
  'lab.removeRule': 'Remove result time',
  'today.overdueShipments': 'Overdue lab results',
  'today.noOverdueShipments': 'All lab results are on time',
}
